var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-card",
          staticStyle: {
            "min-width": "50vw",
            width: "fit-content",
            "min-height": "50vh",
            height: "fit-content",
          },
        },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v(" New Booking "),
              _c(
                "span",
                {
                  staticStyle: {
                    "font-size": "1rem",
                    "text-overflow": "elipsis",
                  },
                },
                [_vm._v(_vm._s(_vm.plant.name))]
              ),
            ]),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Crate Type" } },
                    [
                      _c(
                        "b-select",
                        {
                          attrs: { placeholder: "Crate Type" },
                          model: {
                            value: _vm.crateType,
                            callback: function ($$v) {
                              _vm.crateType = $$v
                            },
                            expression: "crateType",
                          },
                        },
                        [
                          _c("option", { attrs: { value: "1" } }, [
                            _vm._v(" 1 "),
                          ]),
                          _c("option", { attrs: { value: "5.1" } }, [
                            _vm._v(" 5.1 "),
                          ]),
                          _c(
                            "option",
                            { attrs: { value: "5.2", selected: "" } },
                            [_vm._v(" 5.2 ")]
                          ),
                          _c("option", { attrs: { value: "5.5" } }, [
                            _vm._v(" 5.5 "),
                          ]),
                          _c("option", { attrs: { value: "GPSFood" } }, [
                            _vm._v(" GPS Food "),
                          ]),
                          _c("option", { attrs: { value: "ZEON" } }, [
                            _vm._v(" ZEON "),
                          ]),
                          _c("option", { attrs: { value: "RHODIA" } }, [
                            _vm._v(" RHODIA "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Quantity of crates" } },
                    [
                      _c("b-input", {
                        attrs: { type: "number" },
                        model: {
                          value: _vm.crateNum,
                          callback: function ($$v) {
                            _vm.crateNum = $$v
                          },
                          expression: "crateNum",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                { staticClass: "mb-1", attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Date" } },
                    [
                      _c("b-datepicker", {
                        attrs: {
                          name: "date",
                          "first-day-of-week": 1,
                          locale: "en-CA",
                          icon: "calendar-alt",
                          placeholder: "Date",
                        },
                        model: {
                          value: _vm.date,
                          callback: function ($$v) {
                            _vm.date = $$v
                          },
                          expression: "date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Activity" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type:
                              _vm.leaving == true ? "is-success" : "is-light",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeLeaving(true)
                            },
                          },
                        },
                        [_vm._v(" Delivery/Transfer out ")]
                      ),
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type:
                              _vm.leaving == false ? "is-success" : "is-light",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.changeLeaving(false)
                            },
                          },
                        },
                        [_vm._v(" Collect/Transfer in ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { label: "Shipment Name" } },
                [
                  _c("b-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.title,
                      callback: function ($$v) {
                        _vm.title = $$v
                      },
                      expression: "title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { label: "Comment" } },
                [
                  _c("b-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.comment,
                      callback: function ($$v) {
                        _vm.comment = $$v
                      },
                      expression: "comment",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("footer", { staticClass: "modal-card-foot" }, [
            _c(
              "button",
              {
                staticClass: "button is-info is-fullwidth",
                attrs: { type: "submit" },
              },
              [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }